import React, { useState, useEffect } from 'react'
import './App.css'
import './Admin.css'
import './form.css';
import Error from "./Error"
import AuthenticatedApp from "./AuthenticatedApp"
import LoginPage from "./LoginPage"
import Signup from './signup/signup'
import PaymentPage from './signup/PaymentPage'
import PaySuccess from './PaySuccess'
import PayCancel from './PayCancel'

import LogoutPage from './LogoutPage'
import NewLandingPage from './LandingPage/NewLandingPage'
import LandingPreview from './LandingPage/LandingPreview'
import Loading from './Loading'
import BorrowerSignUpPage from "./BorrowerSignUpPage"
import BorrowerLoginPage from "./BorrowerLoginPage"
import BrandNewLandingPage from './LandingPage/BrandNewLandingPage/index'
import Validation from "./Validation"
import BorrowerForgotPasswordPage from "./BorrowerForgotPasswordPage"
import ManagerSetUp from './ManagerSetup'
// import MortgageGPT from "./MortgageGPT"
import FreddieMacChat from "./MortgageGPT/FreddieMacChat"
import FannieMaeChat from "./MortgageGPT/FannieMaeChat"
import Agreements from "./MortgageGPT/components/Widget/Agreements"
import GuidelinegptRedirect from './MortgageGPT/GuidelinegptRedirect'

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom"
import { Helmet } from 'react-helmet'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'

import { insertCssColors } from './Common'
import { handleAuthExpired } from './syncStrataSession.js'
import { Skeleton, Spin } from 'antd'
import ShareChat from './MortgageGPT/ShareChat'
import CalcGoogain from './CalcGoogain'
import CelebrityQualifier, { GMCCForeigners, GMCCSpecials, GMCCUniversePage, UniverseQualifier } from './GMCCCalculator/GMCCCalculator'
import GMCCQuickIntake from './QuickIntake/GMCCQuickIntake/GMCCQuickIntake'
import LOOnePagerPage from './LOOnePager/LOOnePagerPage'
import QuickIntake from './QuickIntake/QuickIntake'
import { GMCCDisclaimer } from './GMCCCalculator/Disclaimer'
import ActivateLOAccount from './ActivateLOAccount'
import { useSelector, useDispatch } from 'react-redux'
import StatsigWrapper from './statsig/statsigWrapper'

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import eventBus from 'Bus'
dayjs.extend(customParseFormat)
dayjs.extend(localeData)
dayjs.extend(weekday)

let stylesNotApplied = true

if (stylesNotApplied) {
    const customerID = localStorage.getItem('customerid')
    insertCssColors(customerID)
    stylesNotApplied = false
}

function getInitialReferrerZeitroCookie() {
    if (typeof document === 'undefined' || !document.cookie) return ''
    const match = document.cookie.match(/(?:^|; )initial_referrer_zeitro=([^;]+)/)
    return match ? decodeURIComponent(match[1]) : ''
}

function getLosEntryReferrer() {
    if (typeof window === 'undefined') return ''
    let ref = window.sessionStorage.getItem('los_entry_referrer') || ''
    if (!ref) ref = getInitialReferrerZeitroCookie()
    if (!ref && typeof document !== 'undefined') ref = document.referrer || ''
    return ref
}

function App() {

    const [loaded, setLoaded] = useState(false)
    const [PageLoaded, setPageLoaded] = useState(false)
    const [landingPages, setLandingPages] = useState([])
    const [landingUrls, setLandingUrls] = useState([])
    const dispatch = useDispatch()
    const subscription = useSelector(state => {

        return state.subscriptionReducer.currentInfo
    })
    const getInfo = async () => {

        // if (subscription.loading && subscription.loading !== undefined) return
        setPageLoaded(true)
        let token = sessionStorage.getItem("ZeitroA")

        const response = await fetch('/los/getcurrentsubscription', {
            method: 'get',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        })
        if (response.status === 401) {
            handleAuthExpired()
            setPageLoaded(false)
            return
        }
        const DataInfo = await response.json()
        dispatch({ type: "SUBSCRIPTION_INFO", data: { ...DataInfo, loading: true } })
        setPageLoaded(false)
        // sessionStorage.setItem("subscription", JSON.stringify(DataInfo))
    }

    // 获取配置
    const getSetting = async () => {
        let token = sessionStorage.getItem("ZeitroA")
        const response = await fetch("/los/getloanestimatedclosingfee", {
        method: "GET",
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
        },
        });
        
        if (response.status !== 200 || !response) {
            if (response.status === 401) {
                handleAuthExpired()
                return;
            }
            console.log('@-response.status',response.status);
            alert("Looks like there was a problem. Status Code: " + response.status);
            return;
        }
        const result = await response.json();
        if (result.status === "OK") {
            localStorage.setItem('configurations', JSON.stringify(result.configurations));
        }
    };

    // 进入 LOS 时尽早记录 referrer，后续路由跳转到 /signup 时仍可使用
    // www.zeitro.com 经 window.open 打开时 referrer 会丢失，改读父域 cookie initial_referrer_zeitro
    useEffect(() => {
        if (typeof window === 'undefined') return
        try {
            const key = 'los_entry_referrer'
            const existing = window.sessionStorage.getItem(key)
            if (!existing) {
                const ref = getLosEntryReferrer()
                if (ref) {
                    window.sessionStorage.setItem(key, ref)
                }
            }
        } catch (e) {
            // ignore
        }
    }, [])

    const generateRealEstateLanding = () => {
        setLoaded(false)
        fetch("/los/getlandingurls", {
            method: "GET",
            headers: {
                Cache: "no-cache",
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.log(
                        "Looks like there was a problem. Status Code: " + response.status
                    )
                    setLoaded(true)
                    return
                }
                response.json().then((js) => {
                    setLandingUrls(js)
                    const routes = []
                    for (let j of js) {
                        const displayTools = JSON.parse(j.ToolstoDisplay)
                        if (j.CustomerID !== "gmcc" && (
                            displayTools.includes("celebrity15K") ||
                            displayTools.includes("celebrityNoratio")
                        )) {
                            j.ToolstoDisplay = JSON.stringify(
                                displayTools.filter(
                                    (tool) =>
                                        tool !== 'celebrity15K' &&
                                        tool !== 'celebrityNoratio'
                                )
                            )
                        }
                        routes.push(
                            <Route
                                key={`brand-new-landing-${j.CustomerID}-${j.LoID}`}
                                exact
                                path={j.Url}
                            >
                                <BrandNewLandingPage
                                    customerid={j.CustomerID}
                                    loid={j.LoID}
                                    url={j.Url}
                                    appurl={j.AppUrl}
                                    toolstoDisplay={j.ToolstoDisplay}
                                />
                            </Route>
                        )
                        routes.push(
                            <Route
                                key={`signin-${j.CustomerID}-${j.LoID}`}
                                exact
                                path={j.Url + '/services/signin'}
                            >
                                <BorrowerLoginPage
                                    appUrl={j.AppUrl}
                                    customerid={j.CustomerID}
                                    loid={j.LoID}
                                    url={j.Url}
                                />
                            </Route>
                        )
                        routes.push(
                            <Route
                                key={`signup-${j.CustomerID}-${j.LoID}`}
                                exact
                                path={j.Url + '/services/signup/'}
                            >
                                <BorrowerSignUpPage
                                    view="signup"
                                    customerid={j.CustomerID}
                                    loid={j.LoID}
                                    url={j.Url}
                                />
                            </Route>
                        )
                        if (j.Url.includes('/gmcc/')) {
                            routes.push(
                                <Route
                                    key={`gmcc-special-${j.CustomerID}-${j.LoID}`}
                                    exact
                                    path={j.Url + '/special'}
                                >
                                    <GMCCSpecials
                                        fromLanding={false}
                                        view="signup"
                                        customerid={j.CustomerID}
                                        loid={j.LoID}
                                        url={j.Url}
                                    />
                                </Route>
                            )
                            routes.push(
                                <Route
                                    key={`gmcc-foreign-nationals-${j.CustomerID}-${j.LoID}`}
                                    exact
                                    path={j.Url + '/ForeignNationals'}
                                >
                                    <GMCCForeigners
                                        fromLanding={false}
                                        view="signup"
                                        customerid={j.CustomerID}
                                        loid={j.LoID}
                                        url={j.Url}
                                    />
                                </Route>
                            )
                        }
                        routes.push(
                            <Route
                                key={`forgot-password-${j.CustomerID}-${j.LoID}`}
                                exact
                                path="/services/forgotpassword"
                            >
                                <BorrowerForgotPasswordPage
                                    appUrl={j.AppUrl}
                                    customerid={j.CustomerID}
                                />
                            </Route>
                        )

                        routes.push(
                            <Route
                                key={`new-landing-${j.CustomerID}-${j.LoID}`}
                                exact
                                path="/services/new-landing-page"
                            >
                                <NewLandingPage
                                    customerid={j.CustomerID}
                                    loid={j.LoID}
                                />
                            </Route>
                        )
                        routes.push(
                            <Route
                                key={`landing-review-${j.CustomerID}-${j.LoID}`}
                                exact
                                path="/services/landing-review"
                            >
                                <LandingPreview
                                    customerid={j.CustomerID}
                                    loid={j.LoID}
                                />
                            </Route>
                        )
                    }

                    setLandingPages(routes)
                    setLoaded(true)
                })
            })
            .catch(function (err) {
                console.log("Fetch Error :", err)
                setLoaded(true)
            })
    }

    useEffect(() => {
        let token = sessionStorage.getItem("ZeitroA")
        if (token) {
            getInfo()
            getSetting();
            eventBus.addListener('updateConfigurations', getSetting)
        }
        generateRealEstateLanding()
        return ()=>{
            eventBus.removeListener('updateConfigurations', getSetting)
        }
    }, [])

    const DefaultRoute = () => {
        if (!loaded) {
            return <Route>
                <div className='p-5'>
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                </div>
            </Route>
        }

        let domainOccupied = false
        let cID, lID, url, appUrl, toolstoDisplay
        // Exact host comparison (tolerating scheme/www./path in the stored
        // Domain) — substring matching used to let one LO's domain capture
        // another LO's site.
        const requestHost = window.location.hostname.toLowerCase().replace(/^www\./, '')
        for (let j of landingUrls) {
            if (j.Domain === "") continue
            const domain = j.Domain
                .toLowerCase()
                .replace(/^https?:\/\//, '')
                .replace(/[/:].*$/, '')
                .replace(/^www\./, '')
            if (requestHost === domain) {
                domainOccupied = true
                cID = j.CustomerID
                lID = j.LoID
                url = j.Url
                appUrl = j.AppUrl
                toolstoDisplay = j.ToolstoDisplay
                break
            }
        }
        if (window.location.host.includes("special.gmccloan.com")) {
            return (
                <Route exact path="/">
                    <StatsigWrapper>
                        <GMCCSpecials view="signup" customerid="gmcc" loid="gmcc" url="www.gmccloan.com" />
                    </StatsigWrapper>
                </Route>
            )
        }
        if (window.location.host.includes("15kgrant.gmccloan.com")) {
            return (
                <Route exact path="/">
                    <StatsigWrapper>
                        <div>
                            <div className="title-2 text-center mt-3 mb-2">GMCC - Celebrity</div>
                            <div className="text-center mb-1">Designed to support underserved borrowers and Communities</div>
                            <CelebrityQualifier customerid="gmcc" loid="gmcc" url="www.gmccloan.com"
                                loEmail="info@gmccloan.com" loPhone="6509961982" loName="" loNMLS="254895" />
                            <div className='p-5'><GMCCDisclaimer /></div>
                        </div>
                    </StatsigWrapper>
                </Route>
            )
        }
        // foreigner.gmccloan.com
        if (window.location.host.includes("foreigner.gmccloan.com")) {
            return (
                <Route exact path="/">
                    <StatsigWrapper>
                        <div>
                            <div className="title-2 text-center mt-4 mb-2">GMCC - Foreign Nationals</div>
                            <div className="text-center mb-1">Designed to support borrowers who are foreign nationals</div>
                            <UniverseQualifier customerid="gmcc" loid="gmcc" type="foreigners" url="www.gmccloan.com"
                                loEmail="info@gmccloan.com" loPhone="6509961982" loName="" loNMLS="254895" />
                            <div className='p-5'><GMCCDisclaimer /></div>
                        </div>
                    </StatsigWrapper>
                </Route>
            )
        }
        if (window.location.host.includes("universe.gmccloan.com")) {
            return (
                <Route exact path="/">
                    <StatsigWrapper>
                        <div>
                            <GMCCUniversePage customerid="gmcc" loid="gmcc" url="www.gmccloan.com"
                                loEmail="info@gmccloan.com" loPhone="6509961982" loName="" loNMLS="254895" />
                        </div>
                        </StatsigWrapper>
                </Route>
            )
        }

        if (!domainOccupied) {
            return (
                <Route exact path="/">
                    <StatsigWrapper>
                        <LoginPage />
                    </StatsigWrapper>
                </Route>
            )
        } else {
            return <Route exact path="/">
                <StatsigWrapper>
                    <BrandNewLandingPage customerid={cID} loid={lID} url={url} appurl={appUrl} toolstoDisplay={toolstoDisplay} />
                </StatsigWrapper>
            </Route>
        }
    }

    return (
        <StatsigWrapper waitForInit={true}>
        <Spin spinning={PageLoaded}>
            <Router>
                <div className="App py-0 my-0">
                    <ManagerSetUp></ManagerSetUp>
                    <Helmet>
                        <title></title>
                    </Helmet>

                    <Switch>
                        {/* Redirect /aaxy/aaxyllc to external URL - must be before other routes */}
                        <Route path="/aaxy/aaxyllc" render={() => {
                            window.location.href = 'https://www.bluerate.ai/loan-officer/xiaomin-james-wu-nmls-244114';
                            return null;
                        }} />
                        {DefaultRoute()}
                        <Route exact path="/newloacount/:hex?">
                            <ActivateLOAccount />
                        </Route>
                        <Route exact path="/login/:customerid?">
                            <LoginPage />
                        </Route>
                        <Route exact path="/testcalgoogain">
                            <CalcGoogain />
                        </Route>

                        <Route path="/app">
                            <AuthenticatedApp />
                        </Route>
                        <Route exact path="/quickintake">
                            <GMCCQuickIntake />
                            {/* <QuickIntake /> */}
                        </Route>
                        {/* The loan officer's own one-page application. Opened from a
                            link, not a signed-in session: the page trades the link for
                            a scoped token itself (LOOnePagerPage).
                            /{customerId}/{encompassLoid}/lo-onepage[/{loanId}] */}
                        <Route exact path="/:customerId/:encompassLoid/lo-onepage/:loanId?">
                            <LOOnePagerPage />
                        </Route>
                        {/* New one-page quick-intake link: /{customerId}/{encompassLoid}/onepage */}
                        <Route exact path="/:customerId/:encompassLoid/onepage">
                            <GMCCQuickIntake />
                        </Route>
                        <Route path="/signup">
                            <Signup />
                        </Route>
                        <Route path="/signupAndPayment">
                            <PaymentPage />
                        </Route>
                        <Route path="/paySuccess">
                            <PaySuccess />
                        </Route>
                        <Route path="/payCancel">
                            <PayCancel />
                        </Route>

                        <Route path="/guidelinegpt/:threadID?">
                            <Helmet>
                                <title>Zeitro Strata AI</title>
                            </Helmet>
                            <GuidelinegptRedirect fromLanding={true} />
                        </Route>

                        {/* 这里的“workflow”根本就没有生效，理论上应该使用 Route exact 严格模式匹配， 建议后面改下*/}
                        {/* <Route path="/guidelinegpt/workflow/:customerid?">
                            <Helmet>
                                <title>Strata AI</title>
                            </Helmet>
                            <MortgageGPT fromLanding={true} />
                        </Route> */}

                        <Route path="/askfreddie">
                            <Helmet>
                                <title>Strata AI - Freddie Mac</title>
                            </Helmet>
                            <FreddieMacChat fromLanding={true} />
                        </Route>

                        <Route path="/askfanniemae">
                            <Helmet>
                                <title>Strata AI - Fannie Mae</title>
                            </Helmet>
                            <FannieMaeChat fromLanding={true} />
                        </Route>

                        <Route path="/services/terms">
                            <Helmet>
                                <title>Zeitro Software as a service agreement</title>
                            </Helmet>
                            <Agreements />
                        </Route>

                        <Route exact path="/services/logout">
                            <LogoutPage />
                        </Route>
                        <Route exact path="/mortgagegpt/sharechat/:threadid">
                            <Helmet>
                                <title>Strata AI - Share chat</title>
                            </Helmet>
                            <ShareChat />
                        </Route>
                        {loaded ? (
                            landingPages
                        ) : (
                            <Route>
                                <Loading />
                            </Route>
                        )}
                        <Route exact path="/services/validate">
                            <Validation />
                        </Route>
                        <Route >
                            <Error code={404} />
                        </Route>
                    </Switch>

                </div>
            </Router>
        </Spin>
        </StatsigWrapper>
    )
}

export default App;
